/**
 * 用于表单处理的增强工具
 * @date 2022/3/21 
 * @author xmetaki(lgz) 
 * @copyright jyht
 */
 import { Message } from 'element-ui';
const __fname = '[@/utils/submitter.js]'

/**
 * checker生成器
 * @param {'Array' | 'String' | 'Number'} dataType 数据类型
 * @param {String} errmsg 报错提示信息 
 * @returns 
 */
export function checkerGenerator(dataType, errmsg) {
    let matcher = () => true
    // TODO: 可以加个tolowcase 手懒先不加
    if (dataType === 'Array') matcher = (val) => Array.isArray(val) && val.length > 0
    if (dataType === 'String') matcher = (val) => val == '0' || !!val
    if (dataType === 'Number') matcher = (val) => val == 0 || !!val

    return function (args) {
        if (!matcher(args)) {
            Message.warning(errmsg || '存在未设置的表单参数')
            return false
        }
        return true
    }
}

/**
 * 提交增强器
 * @param {Object} checkProperty 受检属性
 * @param {Function} cb 检查完毕回调函数
 * @param {Object} propsMap 属性映射
 * @returns 
 */
export  function submitter(checkProperty,cb, propsMap = {}) {
    // try catch没意义不如用这个
    return Promise.resolve().then(() => {
        if (typeof checkProperty !== 'object' || typeof cb !== 'function') {
            console.error(`${__fname} 传参异常`)
            throw new Error('传参异常')
        }
        Object.keys(checkProperty).forEach(name => {
            let arg = checkProperty[name]
            if (typeof arg === 'object' && typeof arg.checker === 'function') {
                if (!arg.checker(arg.$value)) {
                    throw new Error('参数校验失败')
                }
            }
        })
    
        let collector = {}
        Object.keys(checkProperty).forEach(name => {
            if (name in propsMap) {
                collector[propsMap[name]] = checkProperty[name].$value
            } else {
                collector[name] = checkProperty[name].$value
            }
        })
        cb(collector)
    }).catch(err => {
        console.warn(err.message || err)
    })
    
}